import { render, staticRenderFns } from "./AddPagePermissions.vue?vue&type=template&id=3a0503b4&scoped=true"
import script from "./AddPagePermissions.vue?vue&type=script&lang=js"
export * from "./AddPagePermissions.vue?vue&type=script&lang=js"
import style0 from "./AddPagePermissions.vue?vue&type=style&index=0&id=3a0503b4&prod&scoped=true&lang=css"
import style1 from "./AddPagePermissions.vue?vue&type=style&index=1&id=3a0503b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0503b4",
  null
  
)

export default component.exports